<template>
  <div class="h-full org-wrapper">
    <div class="org-create-wrapper">
      <rc-form ref="rcForm" v-bind="{ form, data: formData, formItem, showSearch: false }">
        <template #enterpriseStructureLabel>
          <span style="padding-right: 4px">{{ $t('enterprise.typeOfEnterprise') }}</span>
          <el-tooltip content="普通企业不能建组织，集团型企业可以建二级组织" placement="top">
            <i class="el-icon-warning-outline"></i>
          </el-tooltip>
        </template>
      </rc-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrgCreate",
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formData.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      form: {
        labelPosition: "top",
        gutter: 20
      },
      formData: {
        enterpriseStructure: "COMMON",
        tenantName: "",
        socialCreditCode: "",
        address: "",
        effect: true,
        tenantSource: "LOCAL",
        username: "",
        cellphone: "",
        email: "",
        displayName: "",
        password: "",
        rePassword: "",
        adminMenuType: "ALL"
      },
      formItem: [
        {
          component: "rc-addon-title",
          attribute: {
            label: "基本信息",
            bar: true
          },
          span: 24,
          itemStyle: {
            marginBottom: "10px"
          }
        },
        {
          component: "rc-input",
          label: "租户名称",
          placeholder: "请输入租户名称",
          prop: "tenantName",
          span: 12,
          rules: [
            {
              type: "string",
              required: true,
              pattern: /^\S{2,}$/,
              message: "不能输入空格，长度至少2位"
              // pattern: /^[a-zA-Z0-9\u4e00-\u9fa5]{2,}$/,
              // message: '不能输入空格，长度至少2位且不能含特殊字符'
            }
          ]
        },
        {
          component: "rc-input",
          label: "纳税识别号",
          prop: "socialCreditCode",
          placeholder: "请输入纳税识别号",
          rules: [
            {
              type: "string",
              min: 15,
              required: true,
              pattern: /^[a-zA-Z0-9\u4e00-\u9fa5]{15,}$/,
              message: "请输入正确的纳税识别号"
            }
          ],
          span: 12
        },
        {
          component: "rc-input",
          label: "地址",
          prop: "address",
          placeholder: "请输入地址",
          rules: [
            {
              type: "string",
              required: true,
              message: "请输入地址"
            }
          ],
          span: 24
        },
        {
          component: "rc-select",
          label: "租户类型",
          prop: "enterpriseStructure",
          slotLabel: true,
          span: 12,
          options: [
            {
              label: "普通企业",
              value: "COMMON"
            },
            {
              label: "集团型企业",
              value: "GROUP"
            }
          ],
          rules: [
            {
              type: "string",
              required: true,
              message: "请选择租户类型"
            }
          ],
          events: {
            change: data => this.enterpriseTypeChange(data)
          }
        },
        {
          component: "rc-radio-group",
          label: "租户方式",
          prop: "tenantSource",
          span: 6,
          options: [
            {
              label: "平台租户",
              value: "PLATFORM",
              disabled: false
            },
            {
              label: "本地租户",
              value: "LOCAL",
              disabled: false
            }
          ],
          rules: [
            {
              type: "string",
              required: true,
              message: "请选择租户方式"
            }
          ]
        },
        {
          component: "rc-radio-group",
          label: "状态",
          prop: "effect",
          span: 6,
          options: [
            {
              label: "启用",
              value: true
            },
            {
              label: "禁用",
              value: false
            }
          ],
          rules: [
            {
              type: "boolean",
              required: true
            }
          ]
        },
        {
          component: "rc-addon-title",
          attribute: {
            label: "新增租户管理员",
            bar: true
          },
          span: 24,
          itemStyle: {
            marginBottom: "10px"
          }
        },
        {
          component: "rc-input",
          label: "管理员姓名",
          prop: "displayName",
          placeholder: "请输入管理员姓名",
          rules: [
            {
              type: "string",
              required: true,
              message: "请输入管理员姓名"
            }
          ],
          span: 12
        },
        {
          component: "rc-input",
          label: "用户名",
          prop: "username",
          placeholder: "请输入管理员用户名",
          rules: [
            {
              type: "string",
              required: true,
              message: "请输入管理员用户名"
            }
          ],
          span: 12
        },
        {
          component: "rc-input",
          label: "手机号",
          prop: "cellphone",
          placeholder: "请输入手机号",
          rules: [
            {
              type: "string",
              required: false,
              min: 11,
              max: 11,
              pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
              message: "请输入正确的手机号码"
            }
          ],
          span: 12
        },
        {
          component: "rc-input",
          label: "邮箱",
          prop: "email",
          placeholder: "请输入邮箱",
          rules: [
            {
              type: "string",
              required: false,
              pattern: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
              message: "请输入邮箱"
            }
          ],
          span: 12
        },
        {
          component: "rc-input",
          label: "密码",
          prop: "password",
          showPassword: true,
          rules: [
            {
              required: true,
              message: this.$t("login.enterPassword")
            }
          ],
          placeholder: "请输入管理员密码",
          span: 12
        },
        {
          component: "rc-input",
          label: "确认密码",
          prop: "rePassword",
          showPassword: true,
          placeholder: "请再次输入管理员密码",
          rules: [
            {
              required: true,
              validator: validatePassword
            }
          ],
          span: 12
        },
        {
          component: "rc-radio-group",
          label: "权限级别",
          prop: "adminMenuType",
          span: 12,
          options: [
            {
              label: "全量",
              value: "ALL"
            },
            {
              label: "部分",
              value: "ASSIGNED"
            }
          ],
          rules: [
            {
              type: "string",
              required: "ALL"
            }
          ]
        }
      ]
    };
  },
  methods: {
    enterpriseTypeChange(val) {
      const tenantSource = this.formItem.find(item => item.prop === "tenantSource");
      tenantSource.options.forEach(item => item.disabled = val === "GROUP");
      if (val === "GROUP") {
        this.formData.tenantSource = "LOCAL";
      }
    },
    getFormFunction() {
      return this.$refs.rcForm.getComponentFunctionMap();
    }
  }
};
</script>

<style lang="scss" scoped>
.org-create-wrapper {
  padding: 0;
  height: 100%;

  ::v-deep .router {
    &:hover {
      color: white;
    }
  }
}
</style>
